import JobTitleComponent from 'components/Settings/Masters/JobTitle';
import PermissionGuard from 'components/Global/PermissionGuard';

export const JobTitle = () => {
	return (
		<PermissionGuard permission="Allow_Job_Title">
			<JobTitleComponent />
		</PermissionGuard>
	);
};
